import { AliasService } from './../alias/alias.service';
import { AppConfig } from './../app.config';
import { Observable, empty } from 'rxjs';
import { AwsUtil } from './../authentication/aws.service';
import { CognitoUtil } from './../authentication/cognito.service';
import { DashboardEventService } from './../dashboard/dashboard-event.service';
import { Component, OnInit } from '@angular/core';
import * as AWS from 'aws-sdk';
import { HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { WebApiEndpoints, isTrueString } from '@liquitics/transaction';
import * as Papa from 'papaparse';
import { LocalDBService } from '../service/local-db.service';
// import * as Jimp from 'jimp';
declare var Jimp: any;

const SHOW_APPLICATION_IDENTIFIERS = 'ShowApplicationIdentifiers';
const APPLICATION_IDENTIFICATION_DESCRIPTION = 'ApplicationIdentificationDescription';
const APPLICATION_IDENTIFICATION_COLOR_INDEX = 'ApplicationIdentificationColorIndex';

@Component({
    selector: 'app-application-configuration',
    templateUrl: './application-configuration.component.html',
    styleUrls: ['./application-configuration.component.css']
})
export class ApplicationConfigurationComponent implements OnInit {

    applicationConfigurationVisible = false;
    base64Avatar: any;

    constructor(private dashboardEventService: DashboardEventService,
        private aliasService: AliasService,
        private cognitoUtil: CognitoUtil,
        private awsUtil: AwsUtil,
        private localDBService: LocalDBService,
        public appConfig: AppConfig) {
        const bStr = this.getTenantLocalDBItem(SHOW_APPLICATION_IDENTIFIERS);
        this.appConfig.showApplicationIdentifiers = isTrueString(bStr, false);
        this.appConfig.applicationIdentificationDescription = this.getTenantLocalDBItem(APPLICATION_IDENTIFICATION_DESCRIPTION) || '';
        this.appConfig.applicationIdentificationColorIndex = Number.parseInt(this.getTenantLocalDBItem(APPLICATION_IDENTIFICATION_COLOR_INDEX) || '0');
    }

    ngOnInit() {
    }

    initializeApplicationConfigurationComponent() {
        this.loadAvatar();
    }

    getTenantLocalDBItem(key: string): string {
        return this.localDBService.getItem(`${this.appConfig.getTenantInfo().tenantId}.${key}`);
    }

    setTenantLocalDBItem(key: string, value: string) {
        this.localDBService.setItem(`${this.appConfig.getTenantInfo().tenantId}.${key}`, value);
    }

    handleAvatarUpload(event) {
        for (const file of event.files) {
            // push to s3
            // refresh local avatar
            const fileReader = new FileReader();
            fileReader.readAsArrayBuffer(file);
            fileReader.onload = (evt: Event) => {
                Jimp.read(fileReader.result)
                    .then(j => {
                        j.resize(50, 50)
                            .quality(100)
                            .getBuffer('image/jpeg', (err, data) => {
                                if (err) {
                                    console.log(err);
                                } else {
                                    this.base64Avatar = 'data:' + 'image/jpeg' + ';base64,' + data.toString('base64');
                                    this.saveAvatar();
                                }
                            });
                    });
            };
        }
    }

    handleClientNameUpload(event) {
        for (const file of event.files) {
            // push to s3
            // refresh local avatar
            const fileReader = new FileReader();
            fileReader.readAsText(file);
            fileReader.onload = (evt: Event) => {
                let body = fileReader.result.toString();
                body = 'id,alias' + '\n' + body;
                const parsed = Papa.parse(body, { header: true });
                if (parsed.data) {
                    const validEntries = parsed.data
                        .filter((row: any) => {
                            return row['id'] && row['alias'];
                        });
                    this.aliasService.updateClientAliases(validEntries);
                }
            };
        }
    }


    private saveAvatar(): void {
        const s3 = new AWS.S3();
        const avatarFileName = this.avatarFileName();
        const params = {
            Body: this.base64Avatar,
            ContentEncoding: 'base64',
            Bucket: this.appConfig.getTenantInfo().bucket,
            Key: 'avatars/' + avatarFileName,
            ContentType: 'image/jpeg',
        };
        this.awsUtil.webAPICall(WebApiEndpoints.SaveAvatar, params, true)
            .then((response: any) => {
                this.base64Avatar = response.data;
            })
        // s3.putObject(params, (err, data) => {
        //     if (err) {
        //         console.log(err);
        //     }
        //     this.preferenceVisible = false;
        // });
    }


    private loadAvatar(): void {
        try {
            const avatarFileName = this.avatarFileName();
            const params = {
                Bucket: this.appConfig.getTenantInfo().bucket,
                Key: 'avatars/' + avatarFileName,
            } as AWS.S3.Types.GetObjectRequest;
            const headerBuilder = (token: string) => {
                const headers = new HttpHeaders()
                    .set('Content-Type', 'application/text')
                    // .set('Accept', 'image/jpeg')
                    .set('Authorization', String(token));
                return headers;
            };

            this.awsUtil.webAPICall(WebApiEndpoints.GetAvatar, params, false, headerBuilder)
                .then((response: any) => {
                    this.base64Avatar = new Buffer(response, 'base64').toString('ascii');
                })
                .catch((error: HttpErrorResponse) => {
                    const JsonParseError = 'Http failure during parsing for';
                    const matches = error.message.match(new RegExp(JsonParseError, 'ig'));
                    if (error.status === 200 && matches.length === 1) {
                        this.base64Avatar = error.error.text;
                    } else {
                        throw error;	// re-throw
                    }
                })
                ;
        } catch (e) {
            console.log('Failed to load avatar:' + e);
        }
    }

    private avatarFileName(): string {
        const username = this.cognitoUtil.getCurrentUser().getUsername();
        return username.substring(0, username.indexOf('@')) + '.b64';
    }

    onShowApplicationIdentifiersChanged(event) {
        this.setTenantLocalDBItem(SHOW_APPLICATION_IDENTIFIERS, this.appConfig.showApplicationIdentifiers ? 'TRUE' : 'FALSE');
    }
    onApplicationIdentificationDescriptionChanged(event) {
        this.setTenantLocalDBItem(APPLICATION_IDENTIFICATION_DESCRIPTION, this.appConfig.applicationIdentificationDescription);
    }
    onApplicationIdentificationColorIndexChanged(event) {
        this.setTenantLocalDBItem(APPLICATION_IDENTIFICATION_COLOR_INDEX, String(this.appConfig.applicationIdentificationColorIndex));
    }
}
